import topics from "@/data/topics.json";

const strip = (html) =>
  html.replace(/<br\s*\/?>/g, " ").replace(/<[^>]+>/g, "").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">");

const blockText = (b) => {
  if (b.type === "list") return b.items.map(strip).join(" ");
  if (b.html) return strip(b.html);
  if (b.type === "youtube") return b.title || "";
  if (b.type === "button") return b.label;
  return "";
};

const index = topics.map((t) => {
  const text = t.blocks.map(blockText).filter(Boolean).join(" · ").replace(/\s+/g, " ");
  return { slug: t.slug, title: t.title, text, lower: text.toLowerCase(), titleLower: t.title.toLowerCase() };
});

const snippet = (text, pos, len) => {
  const start = Math.max(0, pos - 70);
  const end = Math.min(text.length, pos + len + 90);
  return {
    before: (start > 0 ? "…" : "") + text.slice(start, pos),
    match: text.slice(pos, pos + len),
    after: text.slice(pos + len, end) + (end < text.length ? "…" : ""),
  };
};

export const searchTopics = (query) => {
  const q = query.trim().toLowerCase();
  if (q.length < 2) return [];
  const results = [];
  for (const t of index) {
    const inTitle = t.titleLower.includes(q);
    let count = 0;
    let first = -1;
    let i = t.lower.indexOf(q);
    while (i !== -1) {
      if (first === -1) first = i;
      count += 1;
      i = t.lower.indexOf(q, i + q.length);
    }
    if (!inTitle && count === 0) continue;
    results.push({
      slug: t.slug,
      title: t.title,
      inTitle,
      count,
      snippet: first === -1 ? null : snippet(t.text, first, q.length),
    });
  }
  return results.sort((a, b) => Number(b.inTitle) - Number(a.inTitle) || b.count - a.count);
};
